export const questions = [
  {
    key: "movePlan",
    text: "When do you plan to move in?",
    label: "Move plan",
    suggestions: [
      "As soon as possible",
      "Within the next 3 months",
      "Later than 3 months",
    ],
    check: 3,
  },
  {
    key: "budgetPricing",
    text: "What’s your monthly budget?",
    label: "Budget pricing",
    suggestions: ["Under €2,000", "€2,000 - €5,000", "Over €5,000"],
    check: 4,
  },
  {
    key: "preferredLocation",
    text: "Preferred location:",
    label: "Preferred location",
    suggestions: [
      // "Close to a metro or public transport",
      "Specific district or area (please specify)",
      "Open to suggestions",
    ],
    check: 5,
  },
  {
    key: "officeType",
    text: "Type of office:",
    label: "Office type",
    suggestions: [
      "Flat (ground floor or apartment-style)",
      "Office building (dedicated floors or business tower)",
      "No preference",
    ],
    check: 6,
  },
  {
    key: "leaseDuration",
    text: "Lease duration:",
    label: "Lease duration",
    suggestions: [
      "Short-term (up to 1 year)",
      "Mid-term (1–3 years)",
      "Long-term (3+ years)",
    ],
    check: 7,
  },
  // {
  //   key: "officeSpaces",
  //   text: "Would you consider coworking or only private spaces?",
  //   label: "Office spaces",
  //   suggestions: [
  //     "Only private offices",
  //     "Open to coworking if private areas are included",
  //     "Coworking is fine",
  //   ],
  //   check: 8,
  // },
  // {
  //   key: "amenities",
  //   text: "Which amenities are important to you? (Choose one or more)",
  //   label: "Amenities",
  //   suggestions: [
  //     "Meeting rooms",
  //     "Kitchenette",
  //     "24/7 access",
  //     "Reception/security",
  //   ],
  //   check: 9,
  // },
  {
    key: "parking",
    text: "Do you need parking?",
    label: "Parking",
    suggestions: ["No parking needed", "1–2 spaces", "3 or more spaces"],
    check: 10,
  },
  {
    key: "accessibilityTransport",
    text: "How important is public transportation access?",
    label: "Transport Access",
    suggestions: [],
    check: 11,
  },
];

// export const questions = [
//   {
//     key: "furnished",
//     text: "Would you like a fully furnished office or an empty space?",
//     label: "Furnished",
//     suggestions: ["Yes", "No"],
//     check: 3,
//   },
//   {
//     key: "budgetPricing",
//     text: "What is your monthly rental budget?",
//     label: "Budget",
//     suggestions: ["Under €5,000", "€5,000 - €15,000", "Over €15,000"],
//     check: 4,
//   },
//   {
//     key: "leaseTermsDuration",
//     text: "What lease duration are you looking for?",
//     label: "Lease Duration",
//     suggestions: [
//       "Short-term (6-12 months)",
//       "Mid-term (1-3 years)",
//       "Long-term (3+ years)",
//     ],
//     check: 5,
//   },
//   {
//     key: "accessibilityTransport",
//     text: "How important is public transportation access?",
//     label: "Transport Access",
//     suggestions: [],
//     check: 6,
//   },
// ];
